import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { PlusLg } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'
import Authentication from '../../../../../models/Authentication'
import axiosService from '../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import { isUgcCreatorTag } from '../../../../../utils/tagStyles'
import TagModal from './TagModal'

export default observer(function TagManagement() {
  const [openModal, setOpenModal] = useState(false)
  const { id } = useParams()
  const { authentications } = useContext(InfluencerContext)

  const currentAuthentication = useMemo(() => authentications.find(authentication => +authentication.id === +id ) || new Authentication(), [id, authentications, authentications.length] )

  const refreshAllTags = () => {
    authentications.forEach(authentication => {
      axiosService.get(`/api/project_manager/authentications/${authentication.id}/tags`)
        .then(tags => authentication.tags = tags)
        .catch(({ data: { error } }) => toastError(error))
    })
  }

  const removeTag = tag => () => {
    const ugc = isUgcCreatorTag(tag)
    if (ugc && authentications.length > 1 && !window.confirm('Remove the UGC Creator tag from all of this creator\'s accounts?')) return
    axiosService.delete(`/api/project_manager/authentications/${currentAuthentication.id}/tags/${tag.id}`)
    .then(deletedTag => {
      toastSuccess('Tag Removed')
      currentAuthentication.tags = currentAuthentication.tags.filter(tag => tag.id !== deletedTag.id)
      if (ugc) refreshAllTags()
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-md">
      <div className="flex justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">Tag management</p>
        <div className="flex items-center">
          <div className="flex rounded-full items-center bg-gray-200/50 dark:bg-rb-dark-mode-lighter px-2 py-1 mr-4">
            <div className="rounded-full w-4 h-4 mr-2 bg-blue-600" />
            <p className="font-semibold text-sm dark:text-white">Public</p>
          </div>
          <div className="flex rounded-full items-center bg-gray-200/50 dark:bg-rb-dark-mode-lighter px-2 py-1">
            <div className="rounded-full w-4 h-4 mr-2 bg-yellow-500" />
            <p className="font-semibold text-sm dark:text-white">Campaign</p>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {currentAuthentication.tags.map(tag => {
          const ugc = isUgcCreatorTag(tag)
          const colorClasses = ugc
            ? 'bg-purple-600/25 text-purple-600 dark:bg-purple-600/20 dark:text-purple-400'
            : tag.campaign_id
              ? 'bg-yellow-500/25 text-yellow-500 dark:bg-yellow-500/20 dark:text-yellow-400'
              : 'bg-blue-600/25 text-blue-600 dark:bg-blue-600/20 dark:text-blue-400'
          return (
            <div key={tag.id} title={ugc ? 'UGC creator - applies to all of this creator\'s accounts' : undefined} className={`flex items-center rounded-full px-2 py-1 font-semibold text-xs ${colorClasses}`}>
              <p className="mr-2">{ugc ? `★ ${tag.name}` : tag.name}</p>
              <button onClick={removeTag(tag)}>X</button>
            </div>
          )
        })}
        <button className="rounded-full p-2 bg-gray-200/50 dark:bg-rb-dark-mode-lighter dark:text-white" onClick={() => setOpenModal(true)}><PlusLg /></button>
        {openModal &&
          <TagModal
            authentication={currentAuthentication}
            isOpen={openModal}
            setIsOpen={setOpenModal}
            onTagAdded={tag => { if (isUgcCreatorTag(tag)) refreshAllTags() }}
          />
        }
      </div>
    </div>
  )
})